import { IconButton, Typography } from '@mui/material';
import Done from '@mui/icons-material/Done';
import { formatTime } from '../utils/format';
import type { RequestItem as RequestItemType } from '../api/types';

/**
 * Una richiesta in coda, con lo stesso stile delle card della lista eventi:
 * titolo in evidenza, dettagli su una riga secondaria, azione a destra.
 */
export function RequestItem({ request, onClose }: { request: RequestItemType; onClose: (id: number) => void }) {
    // Dettagli secondari uniti in un'unica riga (separatore "·"), saltando i vuoti.
    const details = [
        formatTime(request.reqs_date, 'HH:mm:ss'),
        request.user_name,
        request.reqs_author,
        request.type_name,
        request.reqs_tono,
    ].filter((value): value is string => typeof value === 'string' && value.trim().length > 0);

    return (
        <div className="flex items-center gap-4 rounded-2xl bg-white/5 p-3">
            <div className="min-w-0 flex-1">
                <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.125rem' }} noWrap>
                    {request.reqs_title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1rem' }} noWrap>
                    {details.join(' · ')}
                </Typography>
                {request.reqs_dedication && (
                    <Typography variant="body2" color="text.secondary" className="italic" sx={{ fontSize: '1rem' }} noWrap>
                        Dedica: {request.reqs_dedication}
                    </Typography>
                )}
            </div>
            <IconButton
                color="success"
                onClick={() => onClose(request.reqs_id)}
                title="Segna come completata"
                aria-label="Segna come completata"
            >
                <Done sx={{ fontSize: 32 }} />
            </IconButton>
        </div>
    );
}
